<div *ngIf="blocksConfig.editable" class="click-overlay">
</div>
<div [id]="domId + slug"
     class="form-group"
     [gizmoDestinationInput]="formControl"
     [gizmoDestination]="this">
  <fieldset [id]="domId + slug + 'fieldset'">
    <legend class="label name" *ngIf="!block.settings.hide_name">
      <span [class.text-danger]="blocksConfig.editable && blocksConfig.localizable && !block.localizedName(currentContentLocale, originalContentLocale)">
        {{block.localizedName(currentContentLocale, originalContentLocale, true)}}
      </span>
      <pl-required-indicator *ngIf="block.settings.required && blocksConfig.showRequiredIndicator && !ineligible" />
      <pl-readonly-indicator *ngIf="block.settings.readonly && blocksConfig.editable" />
    </legend>

    <ng-container [ngSwitch]="block.styles.format">
      <ng-container *ngSwitchCase="CheckboxInputFormat.LIST">
        <ng-container *ngFor="let option of block.children">
          <div class="custom-control custom-checkbox" [class.custom-control-inline]="block.styles.inline"
               *ngIf="option.settings.name.length > 0 || blocksConfig.editable || isOverlay">

            <input #input
                   [id]="domId + slug + option.id"
                   type="checkbox"
                   class="custom-control-input"
                   [checked]="isChecked(option)"
                   (change)="check(input.checked, option.id)"
                   [disabled]="ineligible || (block.settings.readonly && blocksConfig.submittable && !blocksConfig.editable)"
                   [readonly]="(block.settings.readonly && !blocksConfig.editable) || (!blocksConfig.editable && !blocksConfig.submittable)">
            <label [for]="domId + slug + option.id" class="custom-control-label"
                   [class.text-muted]="option.settings.name.length === 0"
                   [class.is-invalid]="(!blocksConfig.editable || blocksConfig.preview) && blocksConfig.validation && formControl.touched && !isValid()">
              <ng-container *ngIf="!isOverlay">
                <span [class.text-danger]="blocksConfig.editable && blocksConfig.localizable
                                            && !option.localizedName(currentContentLocale, originalContentLocale)
                                            && !(option.settings.name.length === 0)">
                  {{ option.localizedName(currentContentLocale, originalContentLocale, true)
                    || ('blocks.' + block.type + '.new_option' | transloco) }}
                </span>
              </ng-container>
            </label>
          </div>
        </ng-container>
      </ng-container>

      <div class="buttons" *ngSwitchCase="CheckboxInputFormat.BUTTONS">
        <pl-option-buttons [options]="block.children"
                           [currentContentLocale]="currentContentLocale"
                           [originalContentLocale]="originalContentLocale"
                           [data]="data"
                           [disabled]="ineligible || (block.settings.readonly && blocksConfig.submittable && !blocksConfig.editable)"
                           [readonly]="(block.settings.readonly && !blocksConfig.editable) || (!blocksConfig.editable && !blocksConfig.submittable)"
                           [name]="domId"
                           (check)="check($event.checked, $event.id)"
                           [class.full-width]="block.settings.fullWidth"></pl-option-buttons>
      </div>
    </ng-container>

    <div class="d-block text-danger"
         *ngIf="(!blocksConfig.editable || blocksConfig.preview) && blocksConfig.validation && formControl.touched && !isValid()">
      {{'blocks.' + block.type + '.errors.required' | transloco}}
    </div>

    <small *ngIf="block.localizedHelpText(currentContentLocale, originalContentLocale,true)"
           [id]="domId + slug + 'helptext'"
           [class.text-danger]="blocksConfig.editable && blocksConfig.localizable && !block.localizedHelpText(currentContentLocale, originalContentLocale)"
           class="form-text text-muted" aria-hidden="true">
      {{block.localizedHelpText(currentContentLocale, originalContentLocale, true)}}
    </small>
  </fieldset>
</div>

<pl-ineligibility-overlay *ngIf="ineligible" mode="select"></pl-ineligibility-overlay>
